import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventService } from 'src/app/core/service/event.service';
import { LEFT_SIDEBAR_TYPE_CONDENSED, LEFT_SIDEBAR_TYPE_DEFAULT } from '../config/layout.model';
import { BrandItem } from '../models/brands.model';
import { Language } from '../models/language.model';
import { NotificationItem } from '../models/notification.model';
import { ProfileOptionItem } from '../models/profileoption.model';
import {AuthService} from "../../../modules/shared/services/auth.service";
import {LocalStorageService} from "../../../modules/shared/services/local-storage.service";
import {ModalService} from "../../../modules/shared/services/modal.service";
import {ChangePasswordModalComponent} from "./change-password-modal/change-password-modal.component";

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  providers: [ModalService]
})
export class TopbarComponent implements OnInit {

  @Input() layoutType: string = '';
  @Input() leftSidebarTheme: string = 'light';
  notificationList: NotificationItem[] = [];
  languages: Language[] = [];
  brands: BrandItem[] = [];
  profileOptions: ProfileOptionItem[] = [];
  selectedLanguage?: Language;
  loggedInUser: any = {};
  topnavCollapsed: boolean = false;

  // output events
  @Output() mobileMenuButtonClicked = new EventEmitter();


  constructor (
    private authService: AuthService,
    private eventService: EventService,
    private localStorage: LocalStorageService,
    private modalService: ModalService
  ) {

  }

  ngOnInit(): void {
    this.setMenuCollapsingState();
    this._fetchNotifications();
    this._fetchBrands();

    this.loggedInUser = this.authService.getUser();
  }

  setMenuCollapsingState() {
    const collapsed = this.localStorage.getItem('collapsed');

    if (collapsed) {
      this.eventService.broadcast('changeLeftSidebarType', LEFT_SIDEBAR_TYPE_CONDENSED);
    }
  }

  /**
   * Fetches notifications
   */
  _fetchNotifications(): void {
    this.notificationList = [
      {
        text: 'Dodatki do produktów',
        subText: 'Od teraz zarządzanie dodatkami do produktów przenieśliśmy bezpośrednio o szczegółów produktów. Będziesz miał wszystko pod ręką!',
        icon: 'mdi mdi-comment-account-outline',
        bgColor: 'danger',
        redirectTo: '/apps/restaurant/menu/details'
      },
    ];
  }

  /**
   * Fetches brands
   */
  _fetchBrands(): void {
    this.brands = [{
      id: 1,
      name: 'Slack',
      logo: 'assets/images/brands/slack.png',
    },
    {
      id: 2,
      name: 'Github',
      logo: 'assets/images/brands/github.png',
    },
    {
      id: 3,
      name: 'Dribbble',
      logo: 'assets/images/brands/dribbble.png',
    },
    {
      id: 4,
      name: 'Bitbucket',
      logo: 'assets/images/brands/bitbucket.png',
    },
    {
      id: 5,
      name: 'Dropbox',
      logo: 'assets/images/brands/dropbox.png',
    },
    {
      id: 6,
      name: 'G Suite',
      logo: 'assets/images/brands/g-suite.png',
    }];
  }

  /**
   * changes left sidebar width 
   */
  changeSidebarWidth(): void {
    if (document.body.hasAttribute('data-sidebar-size') && document.body.getAttribute('data-sidebar-size') === "condensed") {
      this.eventService.broadcast('changeLeftSidebarType', LEFT_SIDEBAR_TYPE_DEFAULT);
      this.localStorage.setItem('collapsed', false);
    } else {
      this.eventService.broadcast('changeLeftSidebarType', LEFT_SIDEBAR_TYPE_CONDENSED);
      this.localStorage.setItem('collapsed', true);
    }
  }


  /**
 * Toggle the menu bar when having mobile screen
 */
  toggleMobileMenu(event: any) {
    this.topnavCollapsed = !this.topnavCollapsed;
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  logout() {
    this.authService.logout(true);
  }

    changePassword() {
      this.modalService.openCustomModal(ChangePasswordModalComponent, {}).result.then((result) => {}).catch(() => {});
    }
}
